// TODO: 수정필요
// export const textPrimary = '#FFFFFF';
export const textSecondary = 'rgba(255, 255, 255, 0.64)';
export const textTertiary = '#bac0a3';
export const natural95 = '#F8F77C';

export const primary80 = '#c8f53c';
export const primary40 = '#7E9E10';
export const textWhite = '#FFFFF6';

export const bgBlack = '#0F0F0F';
export const bgRed = '#f74b46';
export const bgSecondary = '#27272a';
export const bgFAQ = '#dfffb411';
